import Box from "@mui/material/Box";
import BreadCrumb from "app/components/BreadCrumb";
import { ScrollableView } from "app/components/ScrollableView";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import ActionBar from "./components/ActionBar";
import AddRegistrationModal from "./components/AddRegistrationModal";
import RegistrationTable from "./components/RegistrationTable";
import {
  selectRegistrationList,
  selectRegistrationLoading,
  selectRegistrationMeta,
} from "./redux/selector";
import registrationSaga from "./redux/saga";
import { registrationActions, reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./styles";

const Registration = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: registrationSaga,
  });

  const rows = useSelector(selectRegistrationList);
  const loading = useSelector(selectRegistrationLoading);
  const meta = useSelector(selectRegistrationMeta);

  useEffect(() => {
    dispatch(registrationActions.getRegistrationList());
  }, [dispatch]);

  const hasMoreItems = meta.currentPage < meta.totalPages;

  const getNextPage = () => {
    if (!loading && hasMoreItems) {
      dispatch(registrationActions.getNextPageItems());
    }
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <BreadCrumb
            title={t("SIDEBAR.REGISTRATION_INSTRUCTIONS")}
            iconPosition="end"
          />
          <ActionBar
            onAddClick={() => dispatch(registrationActions.openAddModal())}
          />
          <Box className={styles.tableContainer}>
            <ScrollableView
              borderless
              height="calc(100vh - 200px)"
              loadMore={getNextPage}
              hasMoreItems={hasMoreItems}
            >
              <RegistrationTable rows={rows} loading={loading} />
            </ScrollableView>
          </Box>
        </Box>
      </Box>
      <AddRegistrationModal />
    </Box>
  );
};

export default Registration;
